/** @jsx jsx */
import { css, jsx } from '@emotion/core'
import { Heading, isEmpty, Text } from 'bold-ui'
import { useAtendimentoContext } from 'hooks/atendimento-context/useAtendimentoContext'
import { Fragment, ReactNode, useMemo } from 'react'

import { MChatFooterInfo } from '../mchat/components/MChatFooterInfo'
import { MChatAnteriorFooterInfoModel } from '../mchat/model-mchat'
import { MCHAT_RF_RESULTADO_BY_STATUS, MChatRfResultadoStatus } from '../model-mChatRf'
import { MChatRfResultadoAlert } from './MChatRfResultadoAlert'

interface MChatRfResultadoViewProps {
  status: MChatRfResultadoStatus
  title: string
  label: string
  description: ReactNode
  content?: ReactNode
  footerInfo?: MChatAnteriorFooterInfoModel
}

export function MChatRfResultadoView(props: Readonly<MChatRfResultadoViewProps>) {
  const { title, status, label, description, content, footerInfo } = props

  const hasContent = !isEmpty(content)
  const hasFooterInfo = !isEmpty(footerInfo)
  const styles = useMemo(() => createStyles(status), [status])

  const {
    cidadao: { dataNascimento },
  } = useAtendimentoContext()

  return (
    <Fragment>
      <Heading level={3} fontWeight='normal' style={styles.heading}>
        <strong css={styles.title}>{title}</strong> | <Text fontSize={1}>{label}</Text>
      </Heading>
      {hasContent && <div css={styles.contentWrapper}>{content}</div>}
      <MChatRfResultadoAlert status={status} style={styles.alert}>
        {description}
      </MChatRfResultadoAlert>
      {hasFooterInfo && <MChatFooterInfo info={footerInfo} cidadaoDataNascimento={dataNascimento} />}
    </Fragment>
  )
}

const createStyles = (status: MChatRfResultadoStatus) => ({
  heading: css`
    margin-bottom: 0.5rem;
  `,
  title: css`
    color: ${MCHAT_RF_RESULTADO_BY_STATUS[status].colorScale.c40};
  `,
  contentWrapper: css`
    padding: 0.5rem 0;
    margin-bottom: 0.5rem;
  `,
  alert: css`
    margin-bottom: 0.5rem;
  `,
})
